<template>
	<div class="page-main">
		
		<div class="main-head">
			<h2 class="title">课程中心</h2>
			<div class="search-box">
				<input class="input" type="text" placeholder="输入课程/教师/院校名称搜索" v-model="filtro">
				<span class="btn" @click="getCourseList(1)"></span>
			</div>
		</div>
		
		<!-- 分类筛选 -->
		<div class="screen-mdl w1200">
			<div class="item">
				<p>级别</p>
				<ul class="list">
					<li :class="{act:item.val===courseLevel}" v-for="(item,index) in courseLevelList" :key="index" 
						@click="changeScreen('courseLevel',item.val)">{{item.title}}</li>
				</ul>
			</div>
			<div class="item">
				<p>层次</p>
				<ul class="list">
					<li :class="{act:item.val===courseMajorLevel}" v-for="(item,index) in courseMajorLevelList" :key="index" 
						@click="changeScreen('courseMajorLevel',item.val)">{{item.title}}</li>
				</ul>
			</div>
			<div class="item" v-if="courseMajorLevel>0">
				<p>学科</p>
				<ul class="list">
					<li :class="{act:item.val===courseSubject}" v-for="(item,index) in courseSubjectList" :key="index" 
						v-show="courseMajorLevel== item.level || item.level == 0" 
						@click="changeScreen('courseSubject',item.val)">{{item.title}}</li>
				</ul>
			</div>
			<div class="item">
				<p>状态</p>
				<ul class="list">
					<li :class="{act:item.val===offerCoursesStu}" v-for="(item,index) in offerCoursesStuList" :key="index" 
						@click="changeScreen('offerCoursesStu',item.val)">{{item.title}}</li>
				</ul>
			</div>
		</div>
		
		<div class="course-wrap w1200">
			<!-- 课程资源列表 -->
			<ul class="course-list">
				<li v-for="(item,index) in listInfo.list" :key="item.courseId" @click="goCourseDetail(item)" >
					<div v-if="item.courseLevelName" class="label" :class="item.courseLevelClass">{{item.courseLevelName}}</div>
					<img class="img" :src="item.courseImg || dfImg" alt="">
					<div class="info">
						<h3>{{item.courseName}}</h3>
						<div class="center">
							<p>{{item.orgName}} | {{item.teacherName}}</p>
						</div>
					</div>
					<div class="btm">
						<span class="term" :class="{gray:item.offerCoursesStu==3}" v-if="item.termName && item.offerCoursesStu!=4">{{item.termName}}</span>
						<span class="status" :class="item.offerCoursesClass">{{item.offerCoursesName}}</span>
						<span class="learn-num">{{item.allChooseCount || 0}}</span>
					</div>
				</li>
			</ul>
			
			<van-empty v-if=" !listInfo.list.length>0"  description="没找到相应课程" />
			
			<!-- 分页 -->
			<div class="paging" v-if="listInfo.pagingList.length>1">
				<span class="prev" @click="changePaging(listInfo.pageNum-1,'listInfo')"><img src="../../static/img/ico-tri.png" alt=""></span>
				<span :class="{active:index==listInfo.pageNum-1}" v-for="(item,index) in listInfo.pagingList" :key="index" 
					@click="changePaging(item,'listInfo')">{{item}}</span>
				<span class="next" @click="changePaging(listInfo.pageNum+1,'listInfo')"><img src="../../static/img/ico-tri.png" alt=""></span>
			</div>
			
			
		</div>
		
	</div>
</template>

<script>
export default {
	data () {
		return {
			// schoolTypeList:[//院校类型 1本科院校 2高职高专 3开发大学
			// 	{ title:'全部', val:'' },
			// 	{ title:'本科院校', val:1 },
			// 	{ title:'高职高专', val:2 },
			// 	{ title:'开发大学', val:3 },
			// ],
			// schoolType:'',
			courseLevelList:[	//课程级别：0普通网课 1省级精品 2国家精品 3省级线上一流 4国家线上一流
				{ title:'全部', val:'' },
				{ title:'省级精品', val:1 },
				{ title:'国家精品', val:2 },
				{ title:'省级线上一流', val:3 },
				{ title:'国家线上一流', val:4 },
			],
			courseLevel:'',
			offerCoursesStuList:[	//开课状态(0:全部,1:即将开课,2:开课中,3:已结课,4:暂未开课)
				{ title:'全部', val:0 },
				{ title:'即将开课', val:1 },
				{ title:'开课中', val:2 },
				{ title:'已结课', val:3 },
				{ title:'暂未开课', val:4 },
			],
			offerCoursesStu:0,
			courseMajorLevelList:[	
				{ title:'全部', val:0 },
				{ title:'本科', val:1 },
				{ title:'高职', val:2 }
			],
			courseMajorLevel:0,
			courseSubjectList:[
				// { title:'全部', val:'',  level:0},
				// { title:'哲学', val:'哲学', level:1 },
				// { title:'文学', val:'文学', level:1 },
				// { title:'教育学', val:'教育学', level:1 },
				// { title:'历史学', val:'历史学', level:1 },
				// { title:'农学', val:'农学', level:1 },
				// { title:'医学', val:'医学', level:1 },
				// { title:'管理学', val:'管理学', level:1 },
				// { title:'法学', val:'法学', level:1 },
				// { title:'理学', val:'理学', level:1 },
				// { title:'工学', val:'工学', level:1 },
				// { title:'经济学', val:'经济学', level:1 },
				// { title:'艺术学', val:'艺术学', level:1 },

				// { title:'资源环境与安全大类', val:'资源环境与安全大类',level:2 },
				// { title:'交通运输大类', val:'交通运输大类',level:2 },
				// { title:'食品药品与粮食大类', val:'食品药品与粮食大类',level:2 },
				// { title:'医药卫生大类', val:'医药卫生大类',level:2 },
				// { title:'文化艺术大类', val:'文化艺术大类',level:2 },
				// { title:'农林牧渔大类', val:'农林牧渔大类',level:2 },
				// { title:'土木建筑大类', val:'土木建筑大类',level:2 },
				// { title:'水利大类', val:'水利大类',level:2 },
				// { title:'生物与化工大类', val:'生物与化工大类',level:2 },
				// { title:'新闻传播大类', val:'新闻传播大类',level:2 },
				// { title:'教育与体育大类', val:'教育与体育大类',level:2 },
				// { title:'能源动力与材料大类', val:'能源动力与材料大类',level:2 },
				// { title:'装备制造大类', val:'装备制造大类',level:2 },
				// { title:'轻工纺织大类', val:'轻工纺织大类',level:2 },
				// { title:'电子信息大类', val:'电子信息大类',level:2 },
				// { title:'财经商贸大类', val:'财经商贸大类',level:2 },
				// { title:'公安与司法大类', val:'公安与司法大类',level:2 },
				// { title:'旅游大类', val:'旅游大类',level:2 },
				// { title:'公共管理与服务大类', val:'公共管理与服务大类',level:2 },
	
			],
			courseSubject:'',
			filtro:'',	//关键词搜索

			
			listInfo:{	//开放课程
				list:[],
				pageNum:1,
				pageSize:16,
				total:0,
				pagingList:[],
			},
		}
	},
	
	async created(){
		await this.$onLaunched;		//监听加载了APP.vue中的onLaunched的异步后执行
		this.getSubjectList()
		this.getCourseList()
	},
  
	computed:{
		
	},
  
	methods:{
		//切换筛选类型
		changeScreen(typeName,val){
			this[typeName] = val
			if(typeName=='courseMajorLevel' && val==0){
				this.courseSubject = ''
			}
			this.getCourseList(1)
		},
		
		//查询教学计划课程数据列表
		getCourseList(){
			const {  courseLevel, courseSubject, offerCoursesStu, filtro, courseMajorLevel } = this
			const {  pageSize, pageNum } = this.listInfo
			this.$axios({
				url:`/jxedu/api/site/teachPlanList`,
				params:{
					//schoolType,	//院校类型 1本科院校 2高职高专 3开发大学
					courseLevel,	//课程级别：0省级精品 1国家精品 2省级线上一流 3国家线上一流
					courseSubject,	//所属学科
					offerCoursesStu,	//开课状态(0:全部,1:即将开课,2:开课中,3:已结课,4:暂未开课)
					courseMajorLevel,	//课程层次:1本科 2高职
					filtro,	//关键词搜索
					pageNum,
					pageSize
				},
			}).then(res=>{
				let list = res.rows
				let total = res.total
				//console.log('list',list)
				list.forEach(item=>{
					switch(item.courseLevel){	//课程级别：0普通网课 1联盟精品课 2国家精品课 3省级精品课
						case 0: item.courseLevelName = ''; item.courseLevelClass = ''; break;
						case 1: item.courseLevelName = '省级精品'; item.courseLevelClass = 'blue'; break;
						case 2: item.courseLevelName = '国家精品'; item.courseLevelClass = 'orange'; break;
						case 3: item.courseLevelName = '省级线上一流'; item.courseLevelClass = 'green'; break;
						case 4: item.courseLevelName = '国家线上一流'; item.courseLevelClass = 'red'; break;
					}
					
					switch(item.offerCoursesStu){	//开课状态：0:全部，1:即将开课,2:开课中,3:已结课,4:暂未开课
						case 1: item.offerCoursesName = '即将开课'; item.offerCoursesClass = 'orange'; break;
						case 2: item.offerCoursesName = '开课中'; item.offerCoursesClass = 'blue'; break;
						case 3: item.offerCoursesName = '已结课'; item.offerCoursesClass = 'gray'; break;
						case 4: item.offerCoursesName = '暂未开课'; item.offerCoursesClass = 'gray'; break;
					}
				})
				
				let num = Math.ceil(total/pageSize)
				let pagingList = []
				if(num>0){
					for(var i=0; i<num; i++){
						pagingList.push(i+1)
					}
				}else{
					pagingList.push(1)
				}
				this.listInfo.list = list
				this.listInfo.total = total
				this.listInfo.pagingList = pagingList

			})
		},
		
		
		//切换分页
		changePaging(num,obj){
			const { pageNum, pagingList } = this[obj]
			if(num < 1 || num > pagingList.length || pageNum == num){
				return
			}
			this[obj].pageNum = num
			switch(obj){
				case 'listInfo':  //开放课堂
					this.getCourseList();
					break;
			}
		},
		
		//获取学科数据
		getSubjectList(){
			this.$axios({
				url:`/jxedu/api/site/findOrgDataDict`,
			}).then(res=>{
				let datas = res.data
				let list = datas.higherList
				list = list.concat(datas.regularList)
				list = list.map(item=>{
					return {
						title:item.dataLabel,
						val:item.dataValue,
						level:(item.typeCode=='gz_course_subject')?2:1
					}
				})
				list.unshift({
					title:'全部',
					val:'',
					level:0
				})
				console.log('list',list)
				this.courseSubjectList = list
			})
		},
		

	}
}
</script>

<style lang="less" scoped>
@import '~@/static/css/pc-course.less';
.page-course{ background:#F7F8FA }
.course-wrap{
	padding:20px 22px 60px; box-sizing: border-box;
	.course-list li{ 
		margin-right:12px; width: 280px;
		&:nth-child(4n+4){ margin-right:0; }
	}
}

</style>



// WEBPACK FOOTER //
// src/pages/course-list/tpl-pc.vue